// Pure helper that merges a server-returned DialerBotV1 onto the local form
// state. Kept separate from the component so the hydration shape — defaults
// preserved when the server omits a field, server values winning otherwise —
// can be locked down in tests.

export function mergeServerBot(localBot, serverBot) {
  if (!serverBot || typeof serverBot !== 'object') return localBot;
  const merged = { ...localBot };
  for (const [k, v] of Object.entries(serverBot)) {
    if (v === undefined) continue;
    merged[k] = v;
  }
  return merged;
}
